import http from "../http-common";

class WorkshopB2BService {
  getAllB2BWorkshops(
    token: any,
    month?: string,
    year?: string,
    expert?: string, 
    status?: string
  ) {
    return http.get("/workshopsb2b", {
      params: {
        month,
        year,
        expert,
        status,
      },
      headers: {
        authorization: `Bearer ${token}`,
      },
    });
  }

  getFilteredB2BWorkshopByLocation(state: string) {
    return http.get(`/workshopsb2b/filter/location?state=${state}`);
  }

  getAllFilteredB2BWorkshop(year: string, month: string) {
    return http.get(`/workshopsb2b/filter?year=${year}&month=${month}`);
  }

  getB2BWorkshop(id: string) {
    return http.get(`/workshopsb2b/${id}`);
  }

  addB2BWorkshop(token: any, workshopData: any) {
    return http.post("/workshopsb2b/add", workshopData, {
      headers: {
        authorization: `Bearer ${token}`,
      },
    });
  }

  updateB2BWorkshop(id: string, workshopData: any) {
    return http.patch(`/workshopsb2b/${id}/update`, workshopData);
  }

  deleteB2BWorkshop(id: string) {
    return http.delete(`/workshopsb2b/${id}`);
  }

  getUniqueCorporates() {
    return http.get(`/workshopsb2b/unique-corporates`);
  }
    downloadB2WorkshopsBillingSheet(
      month: string,
      year: string,
      expert?: string,
      // status?: string,
    ) {
      return http.get(
        `/workshopsb2b/biling-sheet/download/workshops?month=${month}&year=${year}&expert=${expert}`,
        { responseType: "blob" }
      );
    }

}

export default new WorkshopB2BService();
